import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import RSVP from 'rsvp';

class TeamsTeamSettingsRoute extends Route {
  @service store;

  setupController(controller, model) {
    super.setupController(controller, model);

    // Built here rather than by the `{{changeset}}` helper in the template. The
    // helper recomputes whenever its arguments invalidate, which would throw away a
    // buffer that autosave has not committed yet; and the autosave task needs a
    // stable reference it owns rather than one handed to it per render. Same call
    // the helper makes internally.
    const validations = controller.teamValidations;
    controller.set(
      'changeset',
      Changeset(model, lookupValidator(validations), validations),
    );

    const time_regex = /[0-9]{2}:[0-9]{2}/;
    if (!model.archive_time || !time_regex.test(model.archive_time)) return;
    const [hours, minutes] = model.archive_time.split(':');
    if (+hours === 0) {
      controller.set('meridiem', 'am');
      controller.set('time', `${12}:${minutes}`);
    } else if (+hours > 12) {
      controller.set('meridiem', 'pm');
      controller.set(
        'time',
        `${String(+hours - 12).padStart(2, '0')}:${minutes}`,
      );
    } else if (+hours === 12) {
      controller.set('meridiem', 'pm');
      controller.set('time', `12:${minutes}`);
    } else {
      controller.set('meridiem', 'am');
      controller.set('time', `${+hours}:${minutes}`);
    }
  }

  beforeModel() {
    return RSVP.all([this.store.findAll('person')]);
  }

  async model() {
    const team = this.modelFor('operations.teams.team');
    // Resolve `people` up front. `TeamModel#activeMembers` reads `people.content`,
    // which never triggers a fetch, and the membership guard in the controller
    // compares against the resolved roster — neither should depend on whether the
    // API happened to include the relationship.
    await team.people;
    return team;
  }
}

export default instrumentRoutePerformance(TeamsTeamSettingsRoute);
